module.exports = __webpack_public_path__ + "components/country-flag/static/mw-a43e67a9a12c8b61c4a24334b785895a.svg";